import { ApiUtility } from "./ApiUtility";

/** Playlist track product types from PlayListItem.AudioType */
export const PLAYLIST_AUDIO_TYPE = {
  Audio: 5,
  Pravachan: 6,
  DailySatsang: 10,
} as const;

/**
 * Map playlist item audioType → localStorage / API product type used by AudioContext.
 */
export function playlistAudioTypeToProductType(
  audioType: number | undefined
): "audios" | "pravachans" | "DailySatsang" {
  if (audioType === PLAYLIST_AUDIO_TYPE.Pravachan) return "pravachans";
  if (audioType === PLAYLIST_AUDIO_TYPE.DailySatsang) return "DailySatsang";
  return "audios";
}

/**
 * Related-list heading: "username's playlist : playlistname"
 * Breadcrumb / page title should use playList.name only (not this).
 */
export function formatPlaylistHeading(playList: any): string {
  const name = (playList?.name || "").trim();
  const userName = (
    playList?.updatedBy?.userName ||
    playList?.createdBy?.userName ||
    playList?.createdBy?.UserName ||
    ""
  ).trim();
  if (userName && name) return `${userName}'s playlist : ${name}`;
  if (name) return name;
  if (userName) return `${userName}'s playlist`;
  return "Playlist";
}

/** Plain playlist display name for breadcrumb / mobile header (no username). */
export function getPlaylistDisplayName(playList: any): string {
  const name = (playList?.name || "").trim();
  return name || "Playlist";
}

/** Normalize playlist detail items into AudiosContext IAudioItem shape. */
export function mapPlaylistItemsToAudioList(items: any[]): any[] {
  if (!Array.isArray(items)) return [];
  return items.map((item: any, index: number) => ({
    id: item.id,
    name: item.name || "",
    author: item.author || "",
    playing: false,
    audioPath: item.audioPath || item.audioUrl || "",
    audioUrl: item.audioUrl || item.audioPath || "",
    pravachanPath: item.audioPath || item.audioUrl || "",
    pravachanUrl: item.audioUrl || item.audioPath || "",
    lyricsPath: item.lyricsPath || "",
    lyricsHash: item.lyricsHash || "",
    index,
    slug: item.slug || "",
    audioLength: item.audioLength || 0,
    description: item.description || "",
    imagePath: item.coverPagePath || item.imagePath || "",
    audioType: item.audioType,
    lastPosition: item.lastPosition || "0",
    ctime: 0,
  }));
}

class PlaylistService {
  /**
   * Resolve path id for anonymous detail:
   * Mongo ObjectId as-is, otherwise slug-{slug}.
   */
  resolvePlayListId(slugOrId: string): string {
    const raw = (slugOrId || "").trim();
    if (!raw) return "";
    // Already prefixed (deep link / retry)
    if (raw.startsWith("slug-")) return raw;
    if (/^[0-9a-fA-F]{24}$/.test(raw)) return raw;
    return `slug-${raw}`;
  }

  private getLangParam(): string {
    const lan = localStorage.getItem("lan") || "hindi";
    return lan === "hi" ? "hindi" : lan === "en" ? "english" : lan;
  }

  /**
   * Anonymous playlist detail by slug or id.
   * GET /api/playlist/slug-{slug}?lang=…  (baseURL already includes /v1)
   * → https://api.gitaseva.org/v1/api/playlist/slug-myplaylistslug
   */
  getPlaylistDetail = (slugOrId: string, lang?: string) => {
    const logdetails: string[] = [];
    const playListId = this.resolvePlayListId(slugOrId);
    const resolvedLang = lang || this.getLangParam();
    const url =
      "/api/playlist/" +
      encodeURIComponent(playListId) +
      "?lang=" +
      encodeURIComponent(resolvedLang);

    logdetails.push(`action=getPlaylistDetail`);
    logdetails.push(`slugOrId=${slugOrId || "none"}`);
    logdetails.push(`playListId=${playListId || "none"}`);
    logdetails.push(`lang=${resolvedLang}`);
    logdetails.push(`url=${url}`);
    console.log("PlaylistService -> getPlaylistDetail ->", logdetails.join(" | "));

    return ApiUtility.get(url);
  };
}

export default new PlaylistService();
